import React, { Fragment } from 'react';
import { Card, Col, Row } from 'antd';
import { useHistory } from 'react-router-dom';

export default ({ orderDetail }) => {
	const history = useHistory();

	return <Fragment>
		<Card title={<span>Thông tin khách hàng: <b onClick={() => window.open("/customer/" + orderDetail?.customer?.id)} style={{ color: 'rgb(0, 136, 255)', cursor: 'pointer' }}> {orderDetail?.customer?.name} </b> </span>}>
			<Row>
				<Col span={12}>
					<Col>
						<b>ĐỊA CHỈ GIAO HÀNG</b>
					</Col>
					<Col>
						<i>{orderDetail?.customer?.phoneNumber}</i>
					</Col>

					<Col>
						<i>{orderDetail?.deliveryAddress || '---'}</i>
					</Col>
				</Col>
				<Col span={12}>
					<Col>
						<b>ĐỊA CHỈ NHẬN HÓA ĐƠN</b>
					</Col>
					<Col>
						<i>{orderDetail?.billingAddress || '---'}</i>
					</Col>
				</Col>

			</Row>
		</Card>
	</Fragment>;
}
